import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { Button } from "@/components/ui/button";
import { ShieldOff, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NoAccess = () => {
  const { user, logout } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6" data-testid="no-access-view">
      <div className="max-w-md w-full text-left">
        <div className="w-12 h-12 rounded-xl bg-orange-500 flex items-center justify-center mb-6">
          <ShieldOff className="w-6 h-6 text-white" />
        </div>
        <h1 className="text-3xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "'Outfit', sans-serif" }}>
          {t("no_access_title")}
        </h1>
        <p className="text-sm text-slate-500 mt-3 leading-relaxed">{t("no_access_desc")}</p>
        <div className="mt-6 p-4 rounded-lg bg-white border border-slate-200 text-sm">
          <div className="text-slate-500 text-xs uppercase tracking-wider font-semibold mb-1">{t("email")}</div>
          <div className="text-slate-900 font-medium" data-testid="no-access-email">{user?.email}</div>
        </div>
        <Button
          onClick={handleLogout}
          variant="outline"
          data-testid="no-access-logout-button"
          className="mt-6 gap-2 border-slate-300"
        >
          <LogOut className="w-4 h-4" /> {t("logout")}
        </Button>
      </div>
    </div>
  );
};

export default NoAccess;
